export default __webpack_public_path__ + "static/media/home_zh.46bd24ab.md";